import calculateTransform from './calculateTransform.js';
export default function (enabledElement) {
    return calculateTransform(enabledElement);
}
